var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2053 13.1267C16.9679 13.3568 16.8588 13.6896 16.9129 14.0159L17.7278 18.5259C17.7965 18.9082 17.6352 19.295 17.3153 19.5159C17.0018 19.7451 16.5847 19.7726 16.2428 19.5892L12.1829 17.4717C12.0417 17.3966 11.885 17.3562 11.7245 17.3517H11.4761C11.39 17.3645 11.3056 17.392 11.2286 17.4342L7.16779 19.5617C6.96704 19.6626 6.73971 19.6983 6.51696 19.6626C5.97429 19.5599 5.61221 19.0429 5.70113 18.4975L6.51696 13.9875C6.57104 13.6584 6.46196 13.3238 6.22454 13.0901L2.91446 9.88175C2.63763 9.61316 2.54138 9.20983 2.66788 8.84591C2.79071 8.48291 3.10421 8.218 3.48279 8.15841L8.03863 7.4975C8.38513 7.46175 8.68946 7.25092 8.84529 6.93925L10.8528 2.82341C10.9005 2.73175 10.9619 2.64741 11.0361 2.57591L11.1186 2.51175C11.1617 2.46408 11.2112 2.42466 11.2662 2.39258L11.3661 2.35591L11.522 2.29175H11.9079C12.2525 2.3275 12.556 2.53375 12.7145 2.84175L14.7486 6.93925C14.8953 7.239 15.1804 7.44708 15.5095 7.4975L20.0653 8.15841C20.4503 8.21342 20.772 8.47925 20.8995 8.84591C21.0195 9.2135 20.916 9.61683 20.6336 9.88175L17.2053 13.1267Z",
    fill: "#D9D9D9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.c24b8c76501eba4f076fc4821f57b529.svg";
export { ForwardRef as ReactComponent };